import moment from "moment/moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import React, { useContext } from "react";
import { useTranslation } from "@i18n/hooks";
import { DiscountUsageSearchContext } from "./DiscountUsageSearchContext";

export const DiscountUsageFilter = () => {
	const { t } = useTranslation("common");
	const { filters, setFilters, clearFilters } = useContext(DiscountUsageSearchContext);

	return (
		<div className="flex flex-wrap align-items-center">
			<div className="mr-2">
				<Calendar
					dateFormat={"dd.mm.yy"}
					value={
						filters.filterByUsedAtFrom
							? moment(filters.filterByUsedAtFrom).toDate()
							: undefined
					}
					showTime
					className="mr-2"
					placeholder={t("discountCode.usageFilter.from")}
					showButtonBar
					onChange={(e) =>
						setFilters({
							...filters,
							filterByUsedAtFrom: e.value
								? moment(e.value as Date).toISOString()
								: undefined,
						})
					}
				/>
				<Calendar
					dateFormat={"dd.mm.yy"}
					value={
						filters.filterByUsedToFrom
							? moment(filters.filterByUsedToFrom).toDate()
							: undefined
					}
					showTime
					showButtonBar
					placeholder={t("discountCode.usageFilter.to")}
					onChange={(e) =>
						setFilters({
							...filters,
							filterByUsedToFrom: e.value
								? moment(e.value as Date).toISOString()
								: undefined,
						})
					}
				/>
			</div>
			<Button
				className="h-2rem"
				tooltip={t("files.reset")}
				icon="pi pi-times"
				onClick={() => clearFilters()}
			/>
		</div>
	);
};
